import React from 'react'
import { Link } from "react-router-dom"
import arrow from '../../../assets/arrow-right-long.svg'
import './A.scss'

const A = ({title, url, classes='', shouldArrow=false, isHref }) => {
  classes = `link ${classes}`

  if (isHref) {
    return <a href={url} target='_blank' className={classes} rel="noreferrer">{title}{shouldArrow && <img src={arrow} alt='arrow' />}</a>
  }

  return (
    <Link to={url} className={classes} >{title}{shouldArrow && <img src={arrow} alt='arrow' />}</Link>
  )
}

export default A